<template>
  <div class="edit-round-tournament-wrapper">
    <b-form @submit="submitForm">
      <b-form-group label="Название раунда" label-for="round_name">
        <b-form-input v-model="formModel.name" id="round_name" required />
      </b-form-group>

      <b-form-group label="Описание раунда" label-for="round_description">
        <b-form-textarea v-model="formModel.description" id="round_description" />
      </b-form-group>

      <b-form-text>⚠️ Введите число в формате: 1.50 или 0.75 и тд</b-form-text>

      <b-form-group label="Коэффициент раунда" label-for="round_coefficient">
        <b-form-input
            id="round_coefficient"
            v-model="formModel.round_coefficient"
            type="number"
            step="0.01"
            required
        />
      </b-form-group>

      <div class="form-footer">
        <b-button :disabled="isLoadingSaveForm" type="submit" variant="primary">
          {{ isLoadingSaveForm ? 'Сохраняем...' : 'Сохранить' }}
        </b-button>
      </div>

      <b-alert v-if="errorText" show variant="danger" class="mt-3">
        {{ errorText }}
      </b-alert>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "EditRoundTournament",
  props: {
    params: { type: Object, required: true }
  },
  data() {
    return {
      isLoadingSaveForm: false,
      errorText: '',
      formModel: {
        name: this.params?.round?.name || '',
        description: this.params?.round?.description || '',
        round_coefficient: this.params?.round?.round_coefficient || ''
      }
    }
  },
  methods: {
    toast(msg, variant = 'default') {
      this.$bvToast.toast(msg, {
        title: variant === 'success' ? 'Готово' : variant === 'danger' ? 'Ошибка' : 'Сообщение',
        variant,            // 'success' | 'danger' | 'warning' | 'info'
        solid: true,
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-right', // положение
        appendToast: false
      })
    },

    async submitForm(event) {
      event.preventDefault()
      this.isLoadingSaveForm = true
      this.errorText = ''

      try {
        await this.$store.dispatch('moduleNewTournament/updateRound', {
          id: this.params.round.id,
          data: {
            name: this.formModel.name,
            ...(this.formModel.description && { description: this.formModel.description }),
            ...(this.formModel.round_coefficient && { round_coefficient: this.formModel.round_coefficient })
          }
        })

        await this.$store.dispatch('moduleNewTournament/getTournament', {
          id: this.$route.params.standingId
        })

        this.toast('Раунд успешно обновлён', 'success')
        this.$emit('closeModal')
      } catch (e) {
        const msg = e?.response?.data?.message || 'Не удалось сохранить. Попробуйте ещё раз.'
        this.errorText = msg
        this.toast(msg, 'danger')
      } finally {
        this.isLoadingSaveForm = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.edit-round-tournament-wrapper {
  .form-footer {
    border-top: 1px solid #dee2e6;
    text-align: right;
    padding-top: 15px;
  }
}
</style>
